import { useQueryParam } from 'use-query-params';
import { BooleanQueryParam } from 'root/src/client/v2/queryParams/helpers/params.helper';
import { useLocation } from 'root/src/client/v2/browser/hooks/useLocation';
export const useIsGiveawayEnter = () => {
    const [isAutoEnter] = useQueryParam('enter_giveaway', BooleanQueryParam());
    const { pathname } = useLocation();
    const creatorsPathPattern = /^\/creators\/[^/]+$/;
    return {
        isGiveawayAutoEnter: isAutoEnter && creatorsPathPattern.test(pathname),
    };
};
